var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1236.000000, -304.000000) translate(358.000000, 296.000000) translate(878.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#8288A2",
    d: "M8.414 10h7.172c.552 0 1 .448 1 1 0 .265-.106.52-.293.707l-3.586 3.586c-.39.39-1.024.39-1.414 0l-3.586-3.586c-.39-.39-.39-1.024 0-1.414.188-.188.442-.293.707-.293z",
    transform: "translate(-1236.000000, -304.000000) translate(358.000000, 296.000000) translate(878.000000, 8.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.b209057109badd19e9a5356f1ac4d036.svg";
export { ForwardRef as ReactComponent };